<template>
  <div v-show="show" v-rect-loading="loading" class="ai-requirement-content">
    <div class="header-container">
      <div v-for="(label, index) in $t(`${i18nPrefix}.message.jobFitConditionTip`)" class="title" :key="index">{{ label }}</div>
    </div>
    <JobFitConditionEditor
      v-if="hasMounted"
      ref="jobFitCondition"
      :jobId="jobInfo.id"
      @change="handleConditionChange"
    ></JobFitConditionEditor>
    <ApplicationTestDialog
      v-if="jobInfo.id"
      ref="applicationTestDialog"
      :jobId="jobInfo.id"
      :jobFitCondition="jobFitCondition"
      :show.sync="dialog.show"
      :loading.sync="dialog.loading"
    ></ApplicationTestDialog>
  </div>
</template>

<script>
import JobFitConditionEditor from './jobFitConditionEditor.vue'
import ApplicationTestDialog from './applicationTestDialog.vue'
import mixin from '../mixin'
import { mapActions } from 'vuex'

export default {
  mixins: [mixin],
  components: {
    JobFitConditionEditor,
    ApplicationTestDialog
  },
  data () {
    return {
      hasForm: false,
      loading: false,
      dialog: {
        show: false,
        loading: false
      },
      jobFitCondition: {},
      jobFitConditionLoader: null,
      hasMounted: false
    }
  },
  computed: {

  },
  created () {
    // 先移除可能存在的监听器，避免重复监听
    // this.$eventBus.$off('testJobFitCondition')
    // this.$eventBus.$on('testJobFitCondition', this.showAiMatchTestCandidate)

    this.$eventBus.$off('resetGeneration')
    this.$eventBus.$on('resetGeneration', this.resetGeneration)
    this.initPage()
  },
  mounted () {

  },
  beforeDestroy () {
    // this.$eventBus.$off('testJobFitCondition')
    this.$eventBus.$off('resetGeneration')
  },
  methods: {
    ...mapActions('jobFit', ['getJobFitCondition']),
    async initPage () {
      await this.loadJobFitCondition()
    },
    async loadJobFitCondition () {
      if (!this.jobInfo.id) {
        return
      }
      if (!this.jobFitConditionLoader) {
        this.jobFitConditionLoader = this.getJobFitCondition(this.jobInfo.id).then((resp) => {
          this.jobFitCondition = resp
        })
      }
      await this.jobFitConditionLoader
      return this.jobFitConditionLoader
    },
    async showAiMatchTestCandidate (reload) {
      // 按钮先隐藏了
      // if (!this.jobInfo.id) {
      //   return
      // }
      // this.dialog.show = true
      // this.dialog.loading = true
      // this.jobFitCondition = await this.$refs.jobFitCondition.getConditionData()
      // await this.$nextTick()
      // this.$refs.applicationTestDialog.refreshData()
    },
    resetGeneration () {
      this.$refs.jobFitCondition.resetCondition(true)
    },
    getConditionData () {
      return this.$refs.jobFitCondition.getConditionData()
    },
    handleConditionChange () {
      this.hasChangedData = true
    }
  },
  watch: {
    show: {
      immediate: true,
      async handler () {
        if (this.show) {
          await this.$nextTick()
          this.hasMounted = true
          let ref = this.$refs.jobFitCondition
          while (!ref) {
            await this.$nextTick()
            ref = this.$refs.jobFitCondition
          }
          ref.loading = true
          await this.loadJobFitCondition()
          ref.setConditionData(this.jobFitCondition)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-requirement-content {
  .header-container {
    margin-bottom: 50px;
    .title {
      font-size: 16px;
      color: #606266;
      font-weight: 500;
      word-break: break-word;
      margin-bottom: 30px;
    }
  }
}
</style>
